// ============================================
// TREELS - REELS DATA (EASILY EDITABLE)
// ============================================
// To add new reels: Simply add a new object to this array
// Format: { id, title, category, videoUrl, thumbnail (optional) }

export const reelsData = [
  {
    id: 1,
    title: "Wedding Highlights",
    category: "Wedding",
    videoUrl: "https://pub-7de7d824709845798b64eafd721f3491.r2.dev/reels/IMG_0802.MOV",
    thumbnail: null
  },
  {
    id: 2,
    title: "Celebration Moments",
    category: "Event",
    videoUrl: "https://pub-7de7d824709845798b64eafd721f3491.r2.dev/reels/IMG_1567.MOV",
    thumbnail: null
  },
  {
    id: 3,
    title: "Corporate Event",
    category: "Corporate",
    videoUrl: "https://pub-7de7d824709845798b64eafd721f3491.r2.dev/reels/IMG_3882.MOV",
    thumbnail: null
  },
  {
    id: 4,
    title: "Birthday Special",
    category: "Birthday",
    videoUrl: "https://pub-7de7d824709845798b64eafd721f3491.r2.dev/reels/IMG_4556.MOV",
    thumbnail: null
  },
  {
    id: 5,
    title: "Brand Promotion",
    category: "Brand",
    videoUrl: "https://pub-7de7d824709845798b64eafd721f3491.r2.dev/reels/IMG_7088.MOV",
    thumbnail: null
  },
  {
    id: 6,
    title: "Creative Content",
    category: "Creative",
    videoUrl: "https://pub-7de7d824709845798b64eafd721f3491.r2.dev/reels/IMG_7878.MOV",
    thumbnail: null
  },
  {
    id: 7,
    title: "Event Coverage",
    category: "Event",
    videoUrl: "https://pub-7de7d824709845798b64eafd721f3491.r2.dev/reels/IMG_8391.MOV",
    thumbnail: null
  },
  {
    id: 8,
    title: "Special Moments",
    category: "Special",
    videoUrl: "https://pub-7de7d824709845798b64eafd721f3491.r2.dev/reels/IMG_8393.MOV",
    thumbnail: null
  },
  {
    id: 9,
    title: "Celebration",
    category: "Celebration",
    videoUrl: "https://pub-7de7d824709845798b64eafd721f3491.r2.dev/reels/IMG_8418.MOV",
    thumbnail: null
  },
  {
    id: 10,
    title: "Premium Content",
    category: "Premium",
    videoUrl: "https://pub-7de7d824709845798b64eafd721f3491.r2.dev/reels/IMG_8648.MOV",
    thumbnail: null
  }
];

// ============================================
// SERVICES DATA
// ============================================
export const servicesData = [
  {
    id: 1,
    title: "Wedding & Event Reels",
    description: "Cinematic storytelling for your most precious moments",
    icon: "Heart"
  },
  {
    id: 2,
    title: "Birthday Celebration Reels",
    description: "Capture the joy and excitement of special birthdays",
    icon: "Cake"
  },
  {
    id: 3,
    title: "Corporate Event Reels",
    description: "Professional coverage for business events and conferences",
    icon: "Briefcase"
  },
  {
    id: 4,
    title: "Brand Promotion Reels",
    description: "Elevate your brand with stunning visual content",
    icon: "TrendingUp"
  },
  {
    id: 5,
    title: "Product Reels",
    description: "Showcase your products with premium cinematography",
    icon: "Package"
  },
  {
    id: 6,
    title: "Pooja & Religious Reels",
    description: "Sacred moments captured with reverence and beauty",
    icon: "Sparkles"
  },
  {
    id: 7,
    title: "Car Delivery Reels",
    description: "Celebrate new beginnings with cinematic car reveals",
    icon: "Car"
  },
  {
    id: 8,
    title: "School & Institutional Reels",
    description: "Document educational milestones and achievements",
    icon: "GraduationCap"
  },
  {
    id: 9,
    title: "Cinematic Portrait Reels",
    description: "Personal brand videos that make an impact",
    icon: "User"
  }
];

// ============================================
// TESTIMONIALS DATA
// ============================================
export const testimonialsData = [
  {
    id: 1,
    name: "Rahul Mehta",
    event: "Corporate Event, Hyderabad",
    quote: "Super fast delivery and premium edits. We posted the reel the same night."
  },
  {
    id: 2,
    name: "Anusha Reddy",
    event: "Wedding, Bengaluru",
    quote: "Cinematic output and beautiful storytelling. Delivered before the day ended."
  },
  {
    id: 3,
    name: "Karthik Jain",
    event: "Product Launch, Chennai",
    quote: "Professional execution and impressive turnaround time."
  },
  {
    id: 4,
    name: "Sneha Kapoor",
    event: "Birthday Event, Pune",
    quote: "Smooth experience and classy edits."
  },
  {
    id: 5,
    name: "Srinivas Naidu",
    event: "Corporate Meet, Hyderabad",
    quote: "Consistent quality and clear communication."
  },
  {
    id: 6,
    name: "Priya & Arjun",
    event: "Engagement, Vizag",
    quote: "Same-day delivery that still felt premium."
  }
];

// ============================================
// CLIENT LOGOS DATA
// ============================================
export const clientsData = [
  { id: 1, name: "McD (McDonald's)", type: "brand" },
  { id: 2, name: "Sri Harsha Motors", type: "automotive" },
  { id: 3, name: "Corporate Events", type: "corporate" },
  { id: 4, name: "Wedding Events", type: "wedding" },
  { id: 5, name: "Product Launches", type: "brand" },
  { id: 6, name: "Institutional Events", type: "education" }
];

// ============================================
// ADRUN SERVICES DATA
// ============================================
export const adrunServices = [
  "Highway Billboards",
  "Bus Shelter Advertising",
  "Event & Festival Branding",
  "Poster Design",
  "Hoardings",
  "2D & 3D Motion Posters"
];
